/* eslint-disable react-hooks/exhaustive-deps */
import { AxiosResponse } from "axios";
import { PaginatorPageChangeEvent } from "primereact/paginator";
import { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Loader from "../../../components/loader";
import PrimePaginator from "../../../components/prime-paginator";
import useDidMountEffect from "../../../hook/use-did-mount-effect";
import { APIResponseEntity } from "../../../interface/apiResponse.interface";
import { FilterReq, GetAllAlbumsWithTheirPhotosRespAlbumsEntity, GetAllAlbumsWithTheirPhotosRespEntity, GetAllAlbumsWithTheirPhotosRespPhotosEntity, UserInfoEntity } from "../../../interface/libraryGallery.interface";
import { APIGetAllAlbumsWithTheirPhotos, APIGetSearchPhotosByTagsAndDisplayname } from "../../../service/axios.service";
import { albumsFileExtension, AllowedExcelExtension, AllowedPDFExtension, AllowedPPTExtension, AllowedVideoExtension, AllowedWordExtension } from "../../../utils/constants";
import { IsNullOrEmptyArray, IsNullOrUndefined, IsStringNullEmptyOrUndefined } from "../../../utils/nullCheck";
import { checkActionAuthorization, getFileFromURL } from "../../../utils/shared.service";


function LibraryGallery({
    CheckedAll, onPhotosUpdate, searchText, breadcrumbItems, signResp, userData
}: {
    CheckedAll: boolean, onPhotosUpdate: (value: GetAllAlbumsWithTheirPhotosRespPhotosEntity[], totalCount: number) => void, searchText: string[] | undefined | null,
    breadcrumbItems: string, signResp: APIResponseEntity | null, userData: UserInfoEntity | null
}) {
    const location = useLocation();
    const navigate = useNavigate();
    const params = new URLSearchParams(location.search);
    const paramAlbumId: string | null = params.get('albumId');

    const currentVideoRef = useRef<HTMLVideoElement | null>(null);

    const [isLoading, setIsLoading] = useState(false);

    const [modelActiveImgIndex, setModelActiveImgIndex] = useState<number>(-1);

    const [albums, setAlbums] = useState<[] | GetAllAlbumsWithTheirPhotosRespAlbumsEntity[] | []>([]);

    const [photos, setPhotos] = useState<[] | GetAllAlbumsWithTheirPhotosRespPhotosEntity[]>([]);

    const [totalPageCount, setTotalPageCount] = useState<number>(0);

    const [totalPageCountForSearchText, setTotalPageCountForSearchText] = useState<number>(0);

    const [filterReq, setFilterReq] = useState<FilterReq>({
        pageSize: 12,
        pageNumber: 0,
        APICallCount: 0,
    });

    const [filterReqForSearchText, setFilterReqForSearchText] = useState<FilterReq>({
        pageSize: 12,
        pageNumber: 0,
        APICallCount: 0,
    });

    useDidMountEffect(() => {
        const fetchDefaultData = async (): Promise<void> => {
            if (
                (searchText && !IsNullOrEmptyArray(searchText))
                ||
                (!searchText || IsNullOrEmptyArray(searchText))
            ) {
                if (filterReq.pageNumber !== 0) {
                    await fetchGallery();
                }
            }
        };
        setFilterReq({
            pageSize: 12,
            pageNumber: 0,
            APICallCount: 0,
        })
        setFilterReqForSearchText({
            pageSize: 12,
            pageNumber: 0,
            APICallCount: 0,
        })
        fetchDefaultData();

    }, [paramAlbumId, userData]);

    useEffect(() => {
        let updatesPhotos: GetAllAlbumsWithTheirPhotosRespPhotosEntity[] = photos.map(v => ({ ...v, isChecked: CheckedAll }));
        onPhotosUpdate(updatesPhotos, updatesPhotos.length)
        setPhotos(updatesPhotos);

    }, [CheckedAll]);

    useEffect(() => {

        const fetchSearchResult = async () => {
            setPhotos([]);
            setAlbums([]);
            onPhotosUpdate([], 0)
            setIsLoading(true);

            let roleId: string = (userData && !IsNullOrUndefined(userData) && !IsStringNullEmptyOrUndefined(userData.roleId)) ? userData.roleId : "";

            const resp: AxiosResponse<APIResponseEntity> = await APIGetSearchPhotosByTagsAndDisplayname(searchText, roleId, filterReqForSearchText.pageNumber, filterReqForSearchText.pageSize);
            setIsLoading(false);

            if (!resp || resp.status !== 200 || !resp.data) {
                return null;
            }

            const axiosResp: APIResponseEntity = resp.data;

            if (axiosResp.statusCode !== 200 || !axiosResp.data) {
                return null;
            }

            const data = axiosResp.data.data;
            if (!IsNullOrEmptyArray(data)) {
                const searchPhotos = data.map((photo: GetAllAlbumsWithTheirPhotosRespPhotosEntity) => ({
                    ...photo,
                    isChecked: false,
                }));

                setPhotos(searchPhotos);
                onPhotosUpdate(searchPhotos, axiosResp.data.totalCount);
                setTotalPageCountForSearchText(axiosResp.data.totalCount)
            }
        };

        const delayDebounceFn = setTimeout(async () => {
            !searchText || IsNullOrEmptyArray(searchText) ? (await fetchGallery()) : await fetchSearchResult();
        }, 300);

        return () => {
            clearTimeout(delayDebounceFn);
        };

    }, [searchText, filterReq, filterReqForSearchText]);

    useEffect(() => {
        const modalElement = document.getElementById(
            "photosGalleryModel"
        ) as HTMLElement | null;

        if (modalElement) {
            modalElement.addEventListener("hidden.bs.modal", () => {
                resetCarousel();
            });

            return () => {
                modalElement.removeEventListener("hidden.bs.modal", resetCarousel);
            };
        }

    }, []);

    useEffect(() => {
        if (!searchText || IsNullOrEmptyArray(searchText)) {
            setFilterReqForSearchText({
                pageSize: 12,
                pageNumber: 0,
                APICallCount: 0,
            })
        }

    }, [searchText]);

    const fetchGallery = async (): Promise<void> => {
        setAlbums([]);
        setPhotos([]);

        setIsLoading(true);

        let roleId: string = (userData && !IsNullOrUndefined(userData) && !IsStringNullEmptyOrUndefined(userData.roleId)) ? userData.roleId : ""
        const resp: AxiosResponse<APIResponseEntity> = await APIGetAllAlbumsWithTheirPhotos(paramAlbumId, roleId, filterReq.pageSize, filterReq.pageNumber);

        if (!resp || resp.status !== 200 || !resp.data) {
            setIsLoading(false);
            return;
        }

        const axiosResp: APIResponseEntity = resp.data;

        if (axiosResp.statusCode !== 200 || !axiosResp.data) {
            setIsLoading(false);
            return;
        }
        setIsLoading(false);

        const results: GetAllAlbumsWithTheirPhotosRespEntity = axiosResp.data && axiosResp.data.results ? axiosResp.data.results : null;

        if (!results.isActive || !results.isAlbumAccessible) {
            navigate('/library');
        }

        // if(!results.isAlbumAccessible){
        //      navigate('/library');
        //    //  window.location.reload();          
        //     // setAlbums([]);
        //     // setPhotos([]);      
        // }

        if (!IsNullOrEmptyArray(results.subAlbums)) {
            results.subAlbums = results.subAlbums.map(v => ({
                ...v, isChecked: false,
            }));
        }
        setAlbums(results.subAlbums);
        if (!IsNullOrEmptyArray(results.currentAlbumPhotos)) {
            results.currentAlbumPhotos = results.currentAlbumPhotos.map(v => ({
                ...v, isChecked: false,
            }));
        }
        setPhotos(results.currentAlbumPhotos);
        setTotalPageCount(results.currentAlbumPhotosTotalCount);
        onPhotosUpdate(results.currentAlbumPhotos, results.currentAlbumPhotos.length);
    };

    const onPageChange = (event: PaginatorPageChangeEvent) => {
        const scrollableDiv: HTMLElement | null = document.getElementById('scrollable-div');
        if (scrollableDiv && !IsNullOrUndefined(scrollableDiv)) {
            scrollableDiv.scrollIntoView({
                behavior: "smooth",
                block: "start"
            })
        }
        setFilterReq((prev) => ({
            ...prev,
            pageSize: event.rows,
            pageNumber: event.page,
            APICallCount: prev.APICallCount! + 1,
        }));
    };

    const onPageChangeForSearchText = (event: PaginatorPageChangeEvent) => {
        const scrollableDiv: HTMLElement | null = document.getElementById('scrollable-div');
        if (scrollableDiv && !IsNullOrUndefined(scrollableDiv)) {
            scrollableDiv.scrollIntoView({
                behavior: "smooth",
                block: "start"
            })
        }
        setFilterReqForSearchText((prev) => ({
            ...prev,
            pageSize: event.rows,
            pageNumber: event.page,
            APICallCount: prev.APICallCount! + 1,
        }));
    };

    const downloadPhoto = async (filePath: string, filename: string): Promise<void> => {
        const image = await fetch(filePath, { cache: "no-cache", })
        const imageBlog = await image.blob()
        const imageURL = URL.createObjectURL(imageBlog)
        const link = document.createElement('a')
        link.href = imageURL;
        let filetype: string = (filePath.split('.').pop() || "jpeg");
        link.download = `${filename}.${filetype}` || 'image.jpeg';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };

    const sharePhoto = async (filePath: string, displayFileName: string): Promise<void> => {
        try {
            const file = await getFileFromURL(filePath, displayFileName);

            if (!navigator.canShare || !navigator.canShare({ files: [file] })) {
                const hiddenButton = document.createElement("button");
                hiddenButton.style.display = "none";
                hiddenButton.onclick = getImageURL.bind(null, filePath);
                document.body.appendChild(hiddenButton);
                hiddenButton.click();
                document.body.removeChild(hiddenButton);
                (window as any).flutter_inappwebview.callHandler('getImageURL', filePath)

                return;
            }
            await navigator.share({ files: [file], });
            console.log("Files shared successfully!");
        } catch (error) {
            // const errorMessage = (error as Error).message || "";

            // if (errorMessage.includes("AbortError") || errorMessage.includes("canceled")) {
            //     console.log("User canceled the share action.");
            //     return;
            // }

            // toast.error("Error occurs during sharing the file ", { ...toastOptObj });
            console.error("Error occurs during sharing the file:", error);
        }
    };

    const onPhotoCheckUncheck = (checked: boolean | undefined, photoId: string): void => {

        if (checked !== undefined && typeof checked !== 'boolean') { return; }

        const updatedData = photos.map((item: GetAllAlbumsWithTheirPhotosRespPhotosEntity) =>
            item.photoId === photoId ? { ...item, isChecked: (checked as boolean) } : item
        );
        setPhotos(updatedData);
        onPhotosUpdate(updatedData, updatedData.length)
    };

    const handleFilesOnClick = (url: string): void => {
        const link = document.createElement("a");
        link.href = url;
        link.target = "_blank";
        link.rel = "noopener noreferrer";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    }

    const resetCarousel = (): void => {

        const carouselElement = document.getElementById("carouselExample") as HTMLElement | null;
        if (carouselElement) {
            const carouselItems = carouselElement.querySelectorAll(".carousel-item");
            carouselItems.forEach((item) => {
                item.classList.remove("active");
            });
            setModelActiveImgIndex(-1);
        }
    };

    const getImageURL = (url: string): string => {
        const results: string = url;
        console.log("Image URL :- ", results);
        return results;
    }

    const handleVideoPlay = (event: React.SyntheticEvent<HTMLVideoElement>): void => {
        if (currentVideoRef.current && currentVideoRef.current !== event.currentTarget) {
            currentVideoRef.current.pause();
        }
        currentVideoRef.current = event.currentTarget;
    };

    return (
        <>
            <Loader isLoading={isLoading} />

            <div className="col-12 imageList" >
                {
                    (IsNullOrEmptyArray(albums) &&
                        IsNullOrEmptyArray(photos)) &&
                    <div className="row justify-content-center text-center">
                        <div className="col-auto d-flex flex-column align-items-center">
                            <img src="assets/images/no-record.svg" className="img-fluid mb-2" alt="Info" style={{ width: "40px", opacity: 0.5 }} />
                            <p className="mb-0">No Records Available.</p>
                        </div>
                    </div>
                }

                {
                    !IsNullOrEmptyArray(albums) && (!searchText || IsNullOrEmptyArray(searchText)) &&
                    <>
                        <ul className="librarieImgHldr">
                            {
                                albums.map((item: GetAllAlbumsWithTheirPhotosRespAlbumsEntity, index: number) => (
                                    // (IsNullOrUndefined(userData) ? true : (userData && userData.assignedLibraryAlbums?.includes(item.albumId))) &&
                                    <li key={index} onClick={() => navigate(`/library?albumId=${item.albumId}`)} >
                                        <div className="d-block">
                                            <div className="imgHldr cursor-pointer">
                                                <div className="imgTitle">
                                                    <div className="name">{item.albumName}</div>
                                                    {
                                                        item.subAlbumsCount > 0 &&
                                                        <div className="albums">{`${item.subAlbumsCount} ${item.subAlbumsCount === 1 ? 'album' : 'albums'}`}</div>
                                                    }
                                                    {/* {
                                                        item.albumCounts > 0 &&
                                                        <div className="albums">{`${item.albumCounts} ${item.albumCounts === 1 ? 'photo' : 'photos'}`}</div>
                                                    } */}
                                                </div>

                                                <img src={item.bucketThumbnailImagePath} alt={item.albumId} loading="lazy" className="restrictRightClick" />

                                            </div>
                                        </div>
                                    </li>
                                ))
                            }
                        </ul>
                    </>
                }

                {
                    !IsNullOrEmptyArray(photos) &&
                    <>
                        <ul className="SearchresultWrapper">
                            {
                                photos.map((item: GetAllAlbumsWithTheirPhotosRespPhotosEntity, index: number) => (
                                    <li key={index}>
                                        <div className={`imgHldr ${item.isChecked ? 'active' : ''}`}>
                                            {(
                                                checkActionAuthorization("upgrade", "Access to download photos") ||
                                                checkActionAuthorization("upgrade", "Access to share photos")
                                            ) &&
                                                <div className="checkBoxMain" style={{ zIndex: "999" }}>
                                                    <input className="form-check-input" type="checkbox" onChange={e => onPhotoCheckUncheck(e.target.checked, item.photoId)} checked={item.isChecked} />
                                                </div>
                                            }
                                            <div className="imgTitle">
                                                <div className="downShareMain d-flex align-items-center">
                                                    <div className="albums text-wrap flex-grow-1 displayFileName" style={{ wordBreak: 'break-word', minWidth: 0 }}>{item.displayFileName}</div>
                                                    <div className="iconsHldr d-flex justify-content-end" style={{ width: "3rem", flexShrink: 0 }}>
                                                        {checkActionAuthorization("upgrade", "Access to download photos") &&
                                                            <img className="me-1 cursor-pointer" src="assets/images/import.svg" alt="import"
                                                                style={{ width: "1.2rem", cursor: 'pointer' }}
                                                                onClick={() =>
                                                                    downloadPhoto(item.filePath, item.displayFileName)
                                                                }
                                                            />
                                                        }
                                                        {checkActionAuthorization("upgrade", "Access to share photos") &&
                                                            <img className="cursor-pointer" src="assets/images/export.svg" alt="export"
                                                                style={{ width: "1.2rem", cursor: 'pointer' }}
                                                                onClick={() => sharePhoto(item.filePath, item.displayFileName)}
                                                            />
                                                        }
                                                    </div>
                                                </div>
                                            </div>

                                            {
                                                (albumsFileExtension.includes(item.filePath.split(".").pop()?.toLowerCase() ?? "")) &&
                                                <div
                                                    className="exhibitionsImg"
                                                    data-bs-toggle="modal"
                                                    data-bs-target="#photosGalleryModel"
                                                >
                                                    <img src={item.filePath.includes('.gif') ? item.filePath : item.bucketThumbnailImagePath}
                                                        alt={item.displayFileName} className='cursor-pointer restrictRightClick' loading="lazy" onClick={() => setModelActiveImgIndex(index)} />
                                                </div>
                                            }
                                            {
                                                AllowedVideoExtension.includes(item.filePath.split(".").pop()?.toLowerCase() ?? "") &&
                                                <video controls className="w-100 h-50" onPlay={handleVideoPlay} style={{ position: "absolute", top: "5px" }}>
                                                    <source src={item.filePath} type={`video/${item.filePath.split(".").pop()?.toLowerCase()}`} />
                                                    {/* Your browser does not support the video tag. */}
                                                </video>
                                            }
                                            {
                                                AllowedPDFExtension.includes(item.filePath.split(".").pop()?.toLowerCase() ?? "") &&
                                                <img src='assets/images/pdf-icon.svg' alt={item.displayFileName} loading="lazy" onClick={() => handleFilesOnClick(item.filePath)} style={{ height: '75%', width: '50%' }} className="albumsFileExtension" />
                                            }
                                            {
                                                AllowedWordExtension.includes(item.filePath.split(".").pop()?.toLowerCase() ?? "") &&
                                                <img src='assets/images/word-icon.svg' alt={item.displayFileName} loading="lazy" onClick={() => handleFilesOnClick(item.filePath)} style={{ height: '75%', width: '50%' }} className="albumsFileExtension" />
                                            }
                                            {
                                                AllowedExcelExtension.includes(item.filePath.split(".").pop()?.toLowerCase() ?? "") &&
                                                <img src='assets/images/excel-icon.svg' alt={item.displayFileName} loading="lazy" onClick={() => handleFilesOnClick(item.filePath)} style={{ height: '75%', width: '50%' }} className="albumsFileExtension" />
                                            }
                                            {
                                                AllowedPPTExtension.includes(item.filePath.split(".").pop()?.toLowerCase() ?? "") &&
                                                <img src='assets/images/ppt-icon.svg' alt={item.displayFileName} loading="lazy" onClick={() => handleFilesOnClick(item.filePath)} style={{ height: '75%', width: '50%' }} className="albumsFileExtension" />
                                            }
                                        </div>
                                    </li>
                                ))
                            }
                        </ul>
                        {
                            IsNullOrUndefined(searchText) ?
                                <PrimePaginator
                                    key={filterReq.pageNumber}
                                    onPageChange={onPageChange}
                                    pageNumber={filterReq.pageNumber}
                                    pageSize={filterReq.pageSize}
                                    totalRecords={totalPageCount}

                                /> :
                                <PrimePaginator
                                    key={filterReq.pageNumber}
                                    onPageChange={onPageChangeForSearchText}
                                    pageNumber={filterReqForSearchText.pageNumber}
                                    pageSize={filterReqForSearchText.pageSize}
                                    totalRecords={totalPageCountForSearchText}
                                />

                        }
                    </>
                }

                <div className="container">
                    <div className="modal fade" id="photosGalleryModel" tabIndex={-1} aria-labelledby="exampleModalLabel" aria-hidden="true">
                        <div className="modal-dialog modal-dialog-centered modal-lg imgGallery-modal">
                            <div className="modal-content" >
                                <div className="modal-header modelHeader" >
                                    {/* <ol className="breadcrumb">                                         
                                        <li className="breadcrumb-item" style={{ display: 'flex', alignItems: "center" }}>
                                            <span  className="breadcrumbFront">Home</span>
                                        </li>
                                        {breadcrumbItems.map((item, index) => (
                                            <li
                                                key={index}
                                                className={`breadcrumbFront breadcrumb-item ${index === breadcrumbItems.length - 1 ? "active" : ""}`}
                                                style={{ fontWeight: "900",  }}
                                            >
                                                {index === breadcrumbItems.length - 1 ? (
                                                    item
                                                ) : (
                                                    <span>{item}</span>
                                                )}
                                            </li>
                                        ))} */}
                                    <div className="modal-title breadcrumbFront modelHeading" id="exampleModalLabel" >{`Home / ${breadcrumbItems}`}</div>
                                    <button type="button" className="btn-close" style={{ position: 'absolute', right: "15px" }} data-bs-dismiss="modal" aria-label="Close"></button>
                                    {/* </ol> */}
                                </div>
                                <div className="modal-body" style={{ padding: "10px" }} >
                                    <div id="carouselExample" className="carousel slide" data-bs-ride="carousel">
                                        <div className="carousel-inner">
                                            {!IsNullOrEmptyArray(photos) &&
                                                photos.map((item: GetAllAlbumsWithTheirPhotosRespPhotosEntity, index: number) => (
                                                    (albumsFileExtension.includes(item.filePath.split(".").pop()?.toLowerCase() ?? "")) &&
                                                    <div className={index === modelActiveImgIndex ? "carousel-item active" : "carousel-item"} key={index}>
                                                        <div className="imgGalleryHldr">
                                                            <img src={item.bucketThumbnailImagePath} alt="error" className="albumsFileExtension" />
                                                        </div>
                                                    </div>
                                                ))
                                            }
                                        </div>
                                        <button className="carousel-control-prev" type="button" data-bs-target="#carouselExample" data-bs-slide="prev">
                                            <span className="carousel-control-prev-icon" aria-hidden="true"></span>
                                            <span className="visually-hidden">Previous</span>
                                        </button>
                                        <button className="carousel-control-next" type="button" data-bs-target="#carouselExample" data-bs-slide="next">
                                            <span className="carousel-control-next-icon" aria-hidden="true"></span>
                                            <span className="visually-hidden">Next</span>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default LibraryGallery;